<template>
    <div class="page-table haberTanim mainDiv" id="affix-container">
        <div class="card-base baslikBg">{{hastaAdi}} - Cerrahi Uygulama </div>
        <el-form label-position="top" status-icon :model="hastaForm" :rules="rulesHasta" ref="hastaForm"
                 class="demo-ruleForm">
            <el-row>
                <el-col :lg="24" :md="24" :sm="24" :xs="24">
                    <div>
                        <el-row>
                            <div class="animated fadeInUp"
                                 style="display: flex; justify-content: center; margin-top: 50px; margin-bottom: 30px">
                                <el-col :lg="6" :md="6" :sm="24" :xs="24" class="col-p">
                                    <div class="tarih-border" style="width: 100%">
                                        <div class="tarih-border-icon">
                                            <i class="el-icon-date"></i>
                                        </div>
                                        <div>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <div style="width: 100%;display: flex;justify-content: center">
                                                    <el-form-item prop="cerrahiTarih">
                                                        <el-date-picker
                                                                v-model="hastaForm.cerrahiTarih"
                                                                type="datetime"
                                                                :picker-options="dateRangeOptions"
                                                                format="yyyy-MM-dd HH:mm:ss"
                                                                value-format="yyyy-MM-dd HH:mm:ss"
                                                                placeholder="Cerrahi Uygulama Tarihi"
                                                                default-time="12:00:00">
                                                        </el-date-picker>
                                                    </el-form-item>
                                                </div>
                                            </el-col>
                                        </div>
                                    </div>
                                </el-col>
                            </div>
                        </el-row>
                        <el-row>
                            <el-col :xl="6" :lg="8" :md="10" :sm="24" :xs="24" class="col-p" aria-disabled="true">
                                <div class="card-base card-shadow--medium margin-top-20 demo-box bg-white animated fadeInLeft"
                                     style="position: relative">
                                    <el-form-item
                                            style="position: relative"
                                            prop="disId'">
                                        <dis-s-v-g :ceruygulama="hastaForm.cerrahiUygList" v-on:disMet="getCerrahiDetay"></dis-s-v-g>
                                        <div v-if="disId !==''" class="animated fadeIn gharipDis"></div>
                                        <span v-if="disId !==''" class="animated fadeIn gharipDisYazi">{{disId}}</span>
                                        <el-button v-if="disId !==''" size="mini" class="disIptalButon" @click="disIptal(disId)">
                                            İptal
                                        </el-button>
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :xl="18" :lg="16" :md="14" :sm="24"
                                    :xs="24" class="col-p">
                                <div class="card-base card-shadow--medium margin-top-20 demo-box bg-white animated fadeInLeft dis-sol">
                                    <div class="dis-sol-input">
                                        <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                            <el-form-item label='Ürün: '
                                                          prop="urunId">
                                                <el-select
                                                        v-on:change="disOnayKaydet(disId)"
                                                        :disabled="rightDisable"
                                                        v-model="urunId"
                                                        placeholder='Ürün Seçiniz'
                                                        filterable
                                                        style="width: 100%">
                                                    <el-option v-for="item in urunList"
                                                               :key="item.baslik"
                                                               :label="item.baslik"
                                                               :value="item.urunId"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                            <el-form-item label='Ürün Lot: '
                                                          prop="urunLot">
                                                <el-input
                                                        v-on:change="disOnayKaydet(disId)"
                                                        :disabled="rightDisable"
                                                        @input="urunLot=urunLot.toUpperCase()"
                                                        v-model="urunLot"
                                                        placeholder='Ürün Lot Giriniz'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                            <el-form-item label='Ek Ürün: '
                                                          prop="ekUrunId">
                                                <el-select
                                                        v-on:change="disOnayKaydet(disId)"
                                                        :disabled="rightDisable"
                                                        filterable
                                                        v-model="ekUrunId"
                                                        placeholder='Ek Ürün Seçiniz'
                                                        style="width: 100%">
                                                    <el-option v-for="item in ekUrunList"
                                                               :key="item.ekurunId"
                                                               :label="item.baslik"
                                                               :value="item.ekurunId"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                            <el-form-item label='Ek Ürün Lot: '
                                                          prop="ekUrunLot">
                                                <el-input
                                                        v-on:change="disOnayKaydet(disId)"
                                                        :disabled="rightDisable"
                                                        @input="ekUrunLot=ekUrunLot.toUpperCase()"
                                                        v-model="ekUrunLot"
                                                        placeholder='Ürün Lot Giriniz'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                            <el-form-item label='Ek Tedavi: '
                                                          prop="ekTedaviId">
                                                <el-select
                                                        v-on:change="disOnayKaydet(disId)"
                                                        :disabled="rightDisable"
                                                        filterable
                                                        v-model="ekTedaviId"
                                                        placeholder='Ek Tedavi Seçiniz'
                                                        style="width: 100%">
                                                    <el-option v-for="item in ekTedaviList"
                                                               :key="item.ektedaviId"
                                                               :label="item.baslik"
                                                               :value="item.ektedaviId"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                            <el-form-item label='ISQ: ' prop="isq">
                                                <el-input
                                                        v-on:change="disOnayKaydet(disId)"
                                                        :disabled="rightDisable"
                                                        v-mask="'####################'"
                                                        v-model="isq"
                                                        placeholder='ISQ Giriniz'></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </el-col>
            </el-row>
            <el-col :span="24">
                <el-button class="margin-bottom-50 estas-buton ileriButton" size="small"
                           type="primary"
                           style="float: right;margin-top: 15px;"
                           @click="cerrahiGuncelle">
                    Kaydet
                    <svg width="14.3" height="15.4" xmlns="http://www.w3.org/2000/svg" style="margin-left: 8px">
                        <g>
                            <rect fill="none" id="canvas_background" height="17.4" width="16.3" y="-1" x="-1"/>
                            <g display="none" overflow="visible" y="0" x="0" height="100%" width="100%"
                               id="canvasGrid">
                                <rect fill="url(#gridpattern)" stroke-width="0" y="0" x="0" height="100%"
                                      width="100%"/>
                            </g>
                        </g>
                        <g>
                            <g id="svg_6">
                                <line stroke="#fff" stroke-linecap="undefined" stroke-linejoin="undefined"
                                      id="svg_1" y2="8.69427" x2="13.35044" y1="0.93082" x1="5.58699"
                                      stroke-width="2.5" fill="none"/>
                                <line stroke="#fff" transform="rotate(90 9.593730926513672,10.687480926513674) "
                                      stroke-linecap="undefined" stroke-linejoin="undefined" id="svg_2" y2="14.4442"
                                      x2="13.35044" y1="6.93075" x1="5.83699" stroke-width="2.5" fill="none"/>
                                <line stroke-linecap="undefined" stroke-linejoin="undefined" id="svg_3" y2="8.49066"
                                      x2="5.70942" y1="3.55579" x1="0.77455" fill-opacity="null"
                                      stroke-opacity="null" stroke-width="2" stroke="#fff" fill="none"/>
                                <line transform="rotate(90 3.241995811462401,9.58568859100342) "
                                      stroke-linecap="undefined" stroke-linejoin="undefined" id="svg_4"
                                      y2="12.05312" x2="5.70942" y1="7.11825" x1="0.77455" fill-opacity="null"
                                      stroke-opacity="null" stroke-width="2" stroke="#fff" fill="none"/>
                            </g>
                        </g>
                    </svg>
                </el-button>
            </el-col>
        </el-form>
    </div>
</template>

<script>
    import DisSVG from '@/components/DisSVG'
    import cerrahiService from '../../../WSProvider/CerrahiService'
    import notification from '../../../notification'
    import EventBus from '@/components/event-bus'
    import JQuery from 'jquery';

    let $ = JQuery;
    var hastaFormKlon = {};
    export default {
        name: "CerrahiUygGuncelleme",
        components: {
            DisSVG
        },

        data() {
            return {
                disId: '',
                eskiDisId: '',
                urunId: '',
                urunLot: '',
                ekUrunId: '',
                ekUrunLot: '',
                ekTedaviId: '',
                isq: '',
                rightDisable: true,





                hastaAdi: '',
                updateId: '',
                updateData: [],
                urunList: [],
                ekUrunList: [],
                ekTedaviList: [],
                dateRangeOptions: {
                    firstDayOfWeek: 1,
                },
                hastaForm: {
                    cerrahiTarih: '',
                    cerrahiUygList: [],
                },
                hastaFormKlon: {
                    cerrahiTarih: '',
                    cerrahiUygList: [],
                },
                rulesHasta: {
                    tcNo: [{
                        required: true,
                        message: "Lütfen T.C. No Giriniz",
                        trigger: 'blur'
                    }],
                },
            }
        },
        created(){
            this.updateId = this.$store.state.updateKodu;
        },
        mounted() {
            let self = this;
            EventBus.$on('deneme', function (disId) {
                if (disId) {
                    self.rightDisable = false;
                    if (self.disId !== '') {
                        self.disOnayKaydet(self.disId)
                    }
                    self.disId = disId;
                    var obj = self.hastaForm.cerrahiUygList.find(data => parseInt(data.disId) === disId);
                    if (obj) {
                        self.urunId = obj.urunId;
                        self.urunLot = obj.urunLot;
                        self.ekUrunId = obj.ekUrunId;
                        self.ekUrunLot = obj.ekUrunLot;
                        self.isq = obj.isq;
                        self.ekTedaviId = obj.ekTedaviId;
                    }else{
                        self.urunId = '';
                        self.urunLot = '';
                        self.ekUrunId = '';
                        self.ekUrunLot = '';
                        self.isq = '';
                        self.ekTedaviId = '';
                    }
                }
            });

        },
        methods: {
            disOnayKaydet(disId) {
                let self = this;
                var obj = self.hastaForm.cerrahiUygList.find(data => parseInt(data.disId) === disId);
                if (obj === undefined) {
                    self.hastaForm.cerrahiUygList.push({
                        disId: disId,
                        urunId: self.urunId,
                        urunLot: self.urunLot,
                        ekUrunId: self.ekUrunId,
                        ekUrunLot: self.ekUrunLot,
                        isq: self.isq,
                        ekTedaviId: self.ekTedaviId,
                    });
                } else {
                    obj.urunId = self.urunId;
                    obj.urunLot = self.urunLot;
                    obj.ekUrunId = self.ekUrunId;
                    obj.ekUrunLot = self.ekUrunLot;
                    obj.isq = self.isq;
                    obj.ekTedaviId = self.ekTedaviId;
                }


            },
            disIptal(disId) {
                this.disId = '';
                var obj = this.hastaForm.cerrahiUygList.find(data => data.disId === disId);
                this.hastaForm.cerrahiUygList.splice(this.hastaForm.cerrahiUygList.indexOf(obj),1);
                obj.ekTedaviId = self.ekTedaviId;
                EventBus.$emit("disList", true)
            },

            getCerrahiDetay() {
                let self = this;
                cerrahiService.cerrahiUygulamaDetay(this.updateId).then((response) => {
                    if (response.status === 200) {
                        this.getUrunList();
                        this.getEkUrunList();
                        this.getEkTedaviList();
                        this.hastaAdi  = response.data.hasta;
                        this.hastaForm.cerrahiTarih = response.data.tarih;
                        hastaFormKlon.cerrahiTarih = response.data.tarih;
                        hastaFormKlon.cerrahiUygList = response.data.uygulama;

                        response.data.uygulama.forEach(function (e) {
                            var obj = self.hastaForm.cerrahiUygList.find(data => data.disId === e.disId);
                            if(obj === undefined){
                                self.hastaForm.cerrahiUygList.push({
                                    cuyglmaId: e.cuyglmaId,
                                    disId: e.disId,
                                    urunId: e.urunId,
                                    urunLot: e.urunLot,
                                    ekUrunId: e.ekUrunId,
                                    ekUrunLot: e.ekUrunLot,
                                    isq: e.isq,
                                    ekTedaviId: e.ekTedaviId,
                                });
                            }
                        });
                        EventBus.$emit("disList", true)

                    }
                })
            },
            getUrunList() {
                cerrahiService.urunListesi(1, '', '').then((response) => {
                    if (response.status === 200) {
                        this.urunList = response.data;
                    } else notification.Status(response.status, this)
                })

            },
            getEkUrunList() {
                cerrahiService.ekUrunListesi(1, '', '').then((response) => {
                    if (response.status === 200) {
                        this.ekUrunList = response.data;
                    } else notification.Status(response.status, this)
                })

            },
            getEkTedaviList() {
                cerrahiService.ekTedaviListesi(1, '', '').then((response) => {
                    if (response.status === 200) {
                        this.ekTedaviList = response.data;
                    } else notification.Status(response.status, this)
                })

            },
            disabledDate(time) {
                return time.getTime() < Date.now() - 8.64e7
            },
            cerrahiGuncelle() {
                let self = this;
                var klonDizi = [];
                var dizi = [];
                for (var i = 0; i < self.hastaForm.cerrahiUygList.length; i++) {
                    let obj1 = hastaFormKlon.cerrahiUygList.find(data => data.cuyglmaId === self.hastaForm.cerrahiUygList[i].cuyglmaId);
                    if (obj1 === undefined) {
                        self.updateData.push({
                            durum: 1,
                            urunId: self.hastaForm.cerrahiUygList[i].urunId,
                            urunLot: self.hastaForm.cerrahiUygList[i].urunLot,
                            ekUrunId: self.hastaForm.cerrahiUygList[i].ekUrunId,
                            ekUrunLot: self.hastaForm.cerrahiUygList[i].ekUrunLot,
                            isq: self.hastaForm.cerrahiUygList[i].isq,
                            disId: self.hastaForm.cerrahiUygList[i].disId,
                            ekTedaviId: self.hastaForm.cerrahiUygList[i].ekTedaviId,
                        });

                    }
                    if (self.hastaForm.cerrahiUygList.length !== 0) {
                        let obj2 = hastaFormKlon.cerrahiUygList.find(data => data.cuyglmaId === self.hastaForm.cerrahiUygList[i].cuyglmaId);
                        klonDizi.push(obj2);
                        if (obj2) {
                            for (var key in hastaFormKlon.cerrahiUygList[i]) {
                                if (self.hastaForm.cerrahiUygList[i][key] && self.hastaForm.cerrahiUygList[i][key] !== klonDizi[i][key]) {
                                    let obj3 = self.updateData.find(data => data.cuyglmaId === self.hastaForm.cerrahiUygList[i].cuyglmaId);
                                    if (obj3 === undefined) {
                                        self.updateData.push({
                                            durum: 2,
                                            cuyglmaId: self.hastaForm.cerrahiUygList[i].cuyglmaId,
                                            urunId: self.hastaForm.cerrahiUygList[i].urunId,
                                            urunLot: self.hastaForm.cerrahiUygList[i].urunLot,
                                            ekUrunId: self.hastaForm.cerrahiUygList[i].ekUrunId,
                                            ekUrunLot: self.hastaForm.cerrahiUygList[i].ekUrunLot,
                                            isq: self.hastaForm.cerrahiUygList[i].isq,
                                            disId: self.hastaForm.cerrahiUygList[i].disId,
                                            ekTedaviId: self.hastaForm.cerrahiUygList[i].ekTedaviId,
                                        })
                                    }

                                }
                            }
                        }

                    }
                }
                if (self.hastaForm.cerrahiTarih !== hastaFormKlon.cerrahiTarih) {
                    self.updateData.push({
                        durum: 'tarih',
                        tarih: self.hastaForm.cerrahiTarih
                    })
                }
                for (var j = 0; j < hastaFormKlon.cerrahiUygList.length; j++) {
                    let obj0 = self.hastaForm.cerrahiUygList.find(data => data.cuyglmaId === hastaFormKlon.cerrahiUygList[j].cuyglmaId);
                    if (obj0 === undefined) {
                        self.updateData.push({
                            durum: 0,
                            cuyglmaId: hastaFormKlon.cerrahiUygList[j].cuyglmaId,
                        })
                    }
                }
                cerrahiService.cerrahiUygulamaGuncelle(this.updateId, this.updateData).then((response) => {
                    if (response.status === 200) {
                        notification.Status('success', this, 'Cerrahi Uygulama güncellendi.');
                        this.resetForm('hastaForm');

                        // EventBus.$emit("cerrahiList", true)
                    } else notification.Status(response.status, this);
                })
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                let tabs = this.$store.state.tabList;
                if (tabs.length === 1) {
                    $(".horizontal-nav.pos-top").removeClass("shadowBox");
                }
                var obj = tabs.find(data => data.name === "cerrahiguncelleme");
                if (obj !== undefined) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === "cerrahiguncelleme") {
                            this.$store.state.tabList.splice(index, 1);
                            if (tabs[index]) {
                                this.$store.commit('changeActiveTabs', tabs[index].name);
                            } else {
                                this.$store.commit('changeActiveTabs', tabs[index - 1].name);
                            }
                        }
                    });
                }
            },
        }
    }
</script>

<style scoped>
    .deleteButton {
        position: absolute;
        right: 5px;
        top: 0;
        z-index: 10;
        padding: 5px;
        border-radius: 0 0 0 5px;
    }

    .addButton {
        position: absolute;
        right: 5px;
        bottom: -5px;
        z-index: 10;
        padding: 5px;
        border-radius: 5px 0 0 0;
    }

    .esnek-kutu {
        display: flex;
        justify-content: center;
    }

    .ileriButton {
        margin-right: 3px;
        box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09), 0 3px 6px 0 rgba(0, 0, 0, 0.065)
    }

    .geriButton {
        margin-left: 3px;
        box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09), 0 3px 6px 0 rgba(0, 0, 0, 0.065)
    }

    .siraNo {
        position: absolute;
        background: #9a9a9a;
        top: -5px;
        left: 0;
        border-radius: 0px 5px 5px 0px;
        padding: 5px 10px;
        color: #fff;
        font-weight: bold;
    }


    #agizGorunumu {
        position: relative;
        z-index: 100;
        margin: auto;
        display: block
    }

    #agizGorunumu path {
        cursor: pointer;
        position: relative;
        z-index: 50
    }

    /*#agizGorunumu path:hover {*/
    /*fill: #00cbc0!important*/
    /*}*/

    #agizGorunumu path[data-aktifdis=aktifDis],
    .seciliDis {
        fill: #00cbc0 !important
    }


    #agizGorunumu path[data-index=zIndexPath] {
        position: relative;
        z-index: 100;

    }

    #agizGorunumu path[data-index=zIndexPath]:hover {
        fill: #00cbc0 !important

    }

</style>
<style lang="scss">
    .seciliDis {
        fill: #00cbc0 !important
    }

    .deaktifDis {
        opacity: .3;
        //pointer-events: none;
    }

    .seciliDis.deaktifDis {
        opacity: 1;
    }
</style>